import { render, staticRenderFns } from "./DeleteSingleContact.vue?vue&type=template&id=13d9a846&"
import script from "./DeleteSingleContact.vue?vue&type=script&lang=js&"
export * from "./DeleteSingleContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports